
import {
  MqMinWidthDesktopMedium,
  MqMinWidthTabletMedium,
  MqMinWidthTabletXlarge,
} from '@Tokens/tokens.json';
import { buildFluidSrcSet, buildSrc } from '@Utils/images';

const variants = [1, 2, 3];

export default {
  name: 'EditoSteps',
  props: {
    /**
     * Badge text
     */
    badge: {
      type: String,
      default: undefined,
    },
    /**
     * Step images
     */
    images: {
      type: Array,
      default: undefined,
    },
    /**
     * Steps items
     */
    items: {
      type: Array,
      default: undefined,
    },
    /**
     * Subtitle text
     */
    subtitle: {
      type: String,
      default: undefined,
    },
    /**
     * Title text
     */
    title: {
      type: String,
      default: undefined,
    },
    /**
     * theme variant
     */
    variant: {
      type: Number,
      default: variants[0],
      validator: (variant) => variants.includes(variant),
    },
  },
  computed: {
    cssClass() {
      return [`-variant-${this.variant}`];
    },
    imgSteps() {
      if (!this.images) {
        return undefined;
      }

      return this.images.map((img) => ({
        alt: '',
        height: '364',
        loading: 'lazy',
        role: 'presentation',
        sizes: `${MqMinWidthDesktopMedium} 30vw, ${MqMinWidthTabletXlarge} 45vw, ${MqMinWidthTabletMedium} 80vw, 95vw`,
        src: buildSrc({
          img,
          width: 364,
        }),
        srcset: buildFluidSrcSet({
          img,
          sizes: [364, 432, 728],
        }),
        width: '364',
      }));
    },
  },
};
